import { makeStyles } from 'tss-react/mui';

const useStylesContentContainer: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  contentContainer: {
    width: 'auto',
    margin: 20,
    [theme.breakpoints.down('sm')]: {
      margin: 5,
    },
  },
  contentContainerEdit: {
    marginBottom: 70,
  },
  contentContainerEditCompressed: {
    width: 'calc(100% - 325px)',
    [theme.breakpoints.down('lg')]: {
      width: 'auto',
    },
  },
}));

export default useStylesContentContainer;
